import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Download, Send, Loader2 } from 'lucide-react';
import { archetypeDescriptions } from '../../data/mock';

export function AdminSubmissionModal({ selectedSubmission, setSelectedSubmission, paidEmails, generatingForId, handleAdminGenerateReport, handleDownloadPaidReport, formatDate }) {
  if (!selectedSubmission) return null;
  const isModalPaid = paidEmails.has((selectedSubmission.user_data?.email || '').toLowerCase());

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-6 z-50" onClick={() => setSelectedSubmission(null)}>
      <Card className="w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <CardHeader><CardTitle>Submission Details</CardTitle></CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">Contact Information</h3>
            <p className="text-sm"><span className="font-medium">Name:</span> {selectedSubmission.user_data?.name}</p>
            <p className="text-sm"><span className="font-medium">Company:</span> {selectedSubmission.user_data?.company_name}</p>
            <p className="text-sm"><span className="font-medium">Email:</span> {selectedSubmission.user_data?.email}</p>
            <p className="text-sm"><span className="font-medium">Submitted:</span> {formatDate(selectedSubmission.submitted_at)}</p>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-2">Results</h3>
            <div className="space-y-2">
              <div className="p-4 bg-purple-50 rounded-lg">
                <div className="font-medium text-purple-900 mb-1">Dominant: {selectedSubmission.results?.dominant}</div>
                <p className="text-sm text-purple-700">{archetypeDescriptions[selectedSubmission.results?.dominant]?.description}</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <div className="font-medium text-gray-900 mb-1">Secondary: {selectedSubmission.results?.secondary}</div>
                <p className="text-sm text-gray-700">{archetypeDescriptions[selectedSubmission.results?.secondary]?.description}</p>
              </div>
            </div>
          </div>

          {selectedSubmission.visual_vibes?.length > 0 && (
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Visual Vibes</h3>
              <div className="flex flex-wrap gap-2">
                {selectedSubmission.visual_vibes.map((vibe, idx) => (
                  <span key={idx} className="px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-sm font-medium">{vibe}</span>
                ))}
              </div>
            </div>
          )}

          <div>
            <h3 className="font-semibold text-gray-900 mb-2">All Scores</h3>
            <div className="grid grid-cols-2 gap-2">
              {selectedSubmission.results?.allScores?.map(({ archetype, count }) => (
                <div key={archetype} className="flex justify-between items-center p-2 bg-gray-50 rounded">
                  <span className="text-sm font-medium">{archetype}</span>
                  <span className="text-sm text-gray-600">{count} points</span>
                </div>
              ))}
            </div>
          </div>

          {!isModalPaid ? (
            <Button onClick={() => handleAdminGenerateReport(selectedSubmission)} disabled={generatingForId === selectedSubmission.id} style={{ background: 'linear-gradient(to right, #7A00EB, #00c3ef)' }} className="w-full text-white hover:opacity-90" data-testid="modal-generate-report-btn">
              {generatingForId === selectedSubmission.id
                ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Generating & Sending...</>
                : <><Send className="h-4 w-4 mr-2" />Generate Premium Report & Email to User</>}
            </Button>
          ) : (
            <Button onClick={() => handleDownloadPaidReport(selectedSubmission.user_data?.email)} variant="outline" className="w-full" data-testid="modal-download-report-btn">
              <Download className="h-4 w-4 mr-2" />
              Download Generated Report
            </Button>
          )}

          <Button onClick={() => setSelectedSubmission(null)} variant="outline" className="w-full">Close</Button>
        </CardContent>
      </Card>
    </div>
  );
}
